import React from 'react'
import { connect } from 'react-redux'

const withUser = WrappedComponent => {
  const WithUser = props => <WrappedComponent {...props} />
  WithUser.displayName = `WithUser(${getDisplayName(WrappedComponent)})`
  return connect(mapStateToProps)(WithUser)
}

function mapStateToProps(state = {}) {
  return { auth: state.auth || {} }
}

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component'
}

export default withUser
